import React from 'react';

import styles from './onboarding.module.css';

// ÐÐ°ÑÑÐ¾ÑÐºÐ°-Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ°: Ð·Ð°Ð³Ð¾Ð»Ð¾Ð²Ð¾Ðº, ÑÐµÐºÑÑ, ÑÑÑÑÑÐ¸Ðº ÑÐ°Ð³Ð¾Ð² Ð¸ ÐºÐ½Ð¾Ð¿ÐºÐ¸.
// ÐÐ¸ÑÐµÐ³Ð¾ Ð½Ðµ ÑÑÐ¸ÑÐ°ÐµÑ Ð¸ Ð½Ðµ Ð¸ÑÐµÑ Ð½Ð° ÑÑÑÐ°Ð½Ð¸ÑÐµ â Ð²ÑÑ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ ÑÐ²ÐµÑÑÑ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÐµÑ
// Ð»ÐµÐ³ÐºÐ¾ Ð¿ÑÐ¾Ð²ÐµÑÐ¸ÑÑ ÑÐµÑÑÐ¾Ð¼ Ð¸ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾.

const TourCard = React.forwardRef(
  ({ title, text, stepNumber, total, ui, position, centered, isLast, isFirst, onNext, onBack, onSkip }, ref) => (
    <div
      ref={ref}
      className={`${styles.card} ${centered ? styles.cardCentered : ''}`}
      style={centered ? undefined : position}
      role="dialog"
      aria-modal="true"
      aria-labelledby="onboarding-card-title"
      tabIndex={-1}
    >
      <h2 className={styles.title} id="onboarding-card-title">
        {title}
      </h2>
      <p className={styles.text}>{text}</p>

      <div className={styles.footer}>
        <span className={styles.counter}>{ui.stepOf(stepNumber, total)}</span>

        <div className={styles.actions}>
          <button type="button" className={styles.skip} onClick={onSkip}>
            {ui.skip}
          </button>
          {!isFirst && (
            <button type="button" className={`${styles.button} ${styles.secondary}`} onClick={onBack}>
              {ui.back}
            </button>
          )}
          <button type="button" className={`${styles.button} ${styles.primary}`} onClick={onNext} autoFocus>
            {isLast ? ui.finish : ui.next}
          </button>
        </div>
      </div>
    </div>
  )
);

TourCard.displayName = 'TourCard';

export default TourCard;
